<div class="dash-nav dash-nav" style="background-color: white;   background: url('assets/bottom-img.png'),url('assets/worldmap.png');background-repeat: no-repeat;background-position:bottom,top;background-size:auto,cover;background-color: white">
    <header>
        <a href="#!" class="menu-toggle">
            <i class="fa fa-bars"></i>
        </a>
        <a href="index.html" class="easion-logo" routerLink="/patdash"><img src="../../../../assets/logo.png" style="width: 171px;
        position: absolute;
        margin: 0 auto;
        text-align: center;
        left: 21px;" /></a>
    </header>
    <nav class="dash-nav-list">
        <a routerLink="/patappointment" class="dash-nav-item" routerLinkActive="active">
            <i class="fa fa-id-card" aria-hidden="true"></i> My Appointments
        </a>
        <a routerLink="/medicalhist" class="dash-nav-item" routerLinkActive="active">
            <i class="fa fa-heartbeat" aria-hidden="true"></i> Pre-Medical
            <br/> Conditions
        </a>
        <a routerLink="/medrepot" class="dash-nav-item" routerLinkActive="active">
            <i class="fa fa-tint" aria-hidden="true"></i> Medical
            <br/> Reports
        </a>
        <a routerLink="/helpdesk" class="dash-nav-item" routerLinkActive="active">
            <i class="fa fa-question" aria-hidden="true"></i> Help
        </a>
        <a routerLink=""aria-hidden="true" class="dash-nav-item" routerLinkActive="active"> Logout</a>
    </nav>
    <p style="color:white;font-size: 15px;word-wrap:break-word;text-align: center;position: absolute;bottom:1px;padding:5px">
        © Copyright <b>MAVIN GLOBUS</b><br /> All Rights Reserved
    </p>
</div>